/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _module = __webpack_require__(1);
	
	(0, _module.loading)();
	
	//ページ内リンクのアニメーション
	//ローディング
	
	(0, _module.anchorScroll)();
	
	//ページTOP
	
	(0, _module.pageTop)();
	
	//画像切り替え
	
	(0, _module.visualChange)();

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var $window = $(window);
	var breakPoint = 767;
	
	var resizeFlag = false;
	var windowWidth = $window.width();
	var windowHeight = $window.height();
	//const bodyLimitHeight = (windowHeight - 185) * 0.88;
	
	var url = location.href;
	
	//ローディング
	var loading = function loading() {
	  var $target = $('#idx-Loading');
	  window.addEventListener('load', function () {
	    setTimeout(function () {
	      $target.fadeOut(600);
	    }, 1000);
	  });
	};
	
	//ページ内リンクのアニメーション
	var anchorScroll = function anchorScroll() {
	  var $anchor = $('a[href^=#]');
	  $anchor.click(function () {
	    var speed = 1000;
	    var href = $(this).attr('href');
	    var target = $(href == '#' || href == '' ? 'html' : href);
	    var position = target.offset().top;
	    $('html, body').animate({
	      scrollTop: position
	    }, speed, 'swing');
	    return false;
	  });
	};
	
	//ページTOP
	var pageTop = function pageTop() {
	  var topBtn = $('.sw-Top');
	  topBtn.css({ visibility: 'hidden', opacity: 0 });
	  $(window).scroll(function () {
	    if ($(this).scrollTop() > 100) {
	      topBtn.css({ visibility: 'visible', opacity: 1 });
	    } else {
	      topBtn.css({ visibility: 'hidden', opacity: 0 });
	    }
	  });
	  topBtn.click(function () {
	    $('body,html').animate({
	      scrollTop: 0
	    }, 1000);
	    return false;
	  });
	};
	
	//画像切り替え
	var visualChange = function visualChange() {
	  var $switcher = $('.js-Visual_Switcher');
	  $switcher.each(function () {
	    var $this = $(this);
	    $(this).children('.btn').click(function () {
	      var index = $($this).children('.btn').index(this);
	      var $visual = $(this).parents('.detail').siblings('.image');
	      $visual.children('img').removeClass('active');
	      $visual.children('img').eq(index).addClass('active');
	      // $('#js-Visual_Switcher li').removeClass('active');
	      // $(this).addClass('active');
	    });
	  });
	};
	
	//export
	exports.loading = loading;
	exports.anchorScroll = anchorScroll;
	exports.pageTop = pageTop;
	exports.visualChange = visualChange;

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// index/app.bundle.js